import React, { useCallback, useEffect, useState } from 'react';
import IconValueCardRow from '../../components/Layout/Dashboard/IconValueCardRow';
import Layout from '../../components/Layout/Layout';

import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../store';
import { UserState } from '../../store/reducers/userReducer';
import { PrefState } from '../../store/reducers/prefReducer';
import { FilterState, setFilterActive } from '../../store/reducers/filterReducer';

import AdminRecommendationService from './../../services/adminRecommendationService';

import moment from 'moment';

import LcIconLink from '../../components/Generic/LcIconLink';
import LcInfiniteTable from "../../components/Data/LcInfiniteTable";
import { PPGrid, PPModal } from 'processor-plataform-ui';
import LCDashboard from '../../components/Data/Dashboard/LCDashboard';
import IconValue from '../../components/Layout/Dashboard/IconValue';
import LcNoData from '../../components/Generic/LcNoData';
import { FilterLcInfiniteTable } from '../../components/Data/Dashboard/LCDashboard/FilterLcInfiniteTable';


interface GroupedRecommendationFilter {
    size: number;
    term: string;
    column: string;
    direction: string;
    category: string;
    subscription: string;
}

const AdminRecommendations: React.FC = (props: any) => {
    const service = new AdminRecommendationService(props);

    const user = useSelector<RootState, UserState>(state => state.user);
    const pref = useSelector<RootState, PrefState>(state => state.pref);
    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(true);
    const [categorySelected, setCategorySelected] = useState<string>('');
    const [showModal, setShowModal] = useState(false);
    const [categories, setCategories] = useState<any[]>();

    const [groupedRecoommendation, setGroupedRecommendation] = useState<any[]>([]);
    const [FilteredGroupedRecoommendation, setFilteredGroupedRecommendation] = useState<any[]>([]);
    const [visibleGroupedRecommendation, setVisibleGroupedRecommendation] = useState<any[] | undefined>(undefined);

    const filterDefault: GroupedRecommendationFilter = {
        size: 20,
        term: "",
        column: "",
        direction: "asc",
        category: "",
        subscription: ""
    };
    const [filterGroupedRecommendation, setFilterGroupedRecommendation] = useState<GroupedRecommendationFilter>(filterDefault);

    const [recommendation, setRecommendation] = useState<any[]>([]);
    const [recommendationFiltered, setRecommendationFiltered] = useState<any[]>([]);
    const [visibleRecommendation, setVisibleRecommendation] = useState<any[]>([]);
    const [filterRecommendation, setFilterRecommendation] = useState<{ size: number, term: string, column: string, direction: string }>(filterDefault);


    //News
    async function loadRecommendations() {
        setIsLoading(true);
        setRecommendation([]);
        setGroupedRecommendation([]);
        setFilteredGroupedRecommendation([]);
        setCategorySelected('');

        await service.GetRecommendations()
            .then((response: any) => {
                debugger;
                //Categorias
                setCategories(response.categories);
                //Recomendações
                response.itens.forEach((item: any) => {
                    setRecommendation(recommendation => [...recommendation, {
                        id: item.name,
                        name: item.name,
                        category: item.properties.category,
                        risk: item.properties.risk,
                        impact: item.properties.impact,
                        description: item.properties.shortDescription.solution,
                        lastUpdated: item.properties.lastUpdated,
                        subscription: item.subscription
                    }]);
                })

                let arrayLevel1: any[] = []
                response.categories.map((element: any, index: number) => {

                    let itens = response.itens.filter(x => x.properties.category == element.displayDescription);
                    let quantity = itens.length;

                    arrayLevel1.push(
                        {
                            id: index,
                            category: itens[0].properties.category,
                            impact: itens[0].properties.impact,
                            quantity: quantity,
                            subscription: itens[0].subscription
                        }
                    )

                })

                setGroupedRecommendation(arrayLevel1)
                setFilteredGroupedRecommendation(arrayLevel1)
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
                setIsLoading(false);
            });
        //setIsLoading(false);
    }

    useEffect(() => {
        loadRecommendations();
    }, [user.ClientGroupSelected, user.refreshFlag]);

    useEffect(() => {
        // setIsLoading(true)
        setVisibleRecommendation([]);
        if (categorySelected) {
            var filtered = recommendation.filter((item: any) => {
                return item.category == categorySelected
            })

            setRecommendationFiltered(filtered);
            setVisibleRecommendation(filtered.slice(0, filterDefault.size))
        } else {
            setRecommendationFiltered(recommendation);
            setVisibleRecommendation(recommendation.slice(0, filterDefault.size))

        }
        categorySelected.length > 0 && setShowModal(true)
        //setIsLoading(false)
    }, [categorySelected])

    useEffect(() => {
        setRecommendationFiltered(recommendation);
    }, [recommendation]);

    const columns = [
        { field: 'name', headerName: 'Recurso', width: "35%" },
        { field: 'impact', headerName: 'Impacto', width: "10%" },
        {
            field: 'risk', headerName: 'Risco', width: "10%",
            renderCell: (row: any) =>
            (
                <span>
                    {row.value == null ?
                        <>Sem riscos</>
                        :
                        <>{row.value}</>
                    }
                </span>
            ),
        },
        { field: 'description', headerName: 'Descrição', width: "35%" },
        {
            field: 'lastUpdated', headerName: 'Atualizado há', width: "10%",
            renderCell: (row: any) =>
            (
                <span>{moment(row.value).format('L')}</span>
            ),
        }
    ];

    const columnsLevel1 = [
        { field: 'category', headerName: 'Categoria', width: "35%" },
        { field: 'subscription', headerName: 'Assinatura', width: "55%" },
        { field: 'quantity', headerName: 'Quantidade', width: "10%" },
        {
            field:'',
            width: '80px', overflow: "visible", sort: false, 
            renderCell: (row: any) => {
                return (
                    <LcIconLink tooltip='Ver recomendações' tooltipPosition='right' icon='lci lci-document-text' color="#2b304f" onClick={() => { setCategorySelected(row.category) }} />
                )
            }
        }
    ];

    // useEffect(() => {
    //     if (filterGroupedRecommendation && FilteredGroupedRecoommendation.length > 0) {
    //         var filtered = groupedRecoommendation.filter((p: any) =>
    //             filterGroupedRecommendation.term == '' ||
    //             p.category?.toLowerCase().indexOf(filterGroupedRecommendation.term) > -1 ||
    //             p.subscription?.toLowerCase().indexOf(filterGroupedRecommendation.term) > -1
    //         )
    //             .sort((a: any, b: any) => {
    //                 if (filterGroupedRecommendation.direction == 'asc') return (a[filterGroupedRecommendation.column] > b[filterGroupedRecommendation.column]) ? 1 : -1;
    //                 else return (a[filterGroupedRecommendation.column] > b[filterGroupedRecommendation.column]) ? -1 : 1;
    //             });

    //         setFilteredGroupedRecommendation(filtered);
    //         setVisibleGroupedRecommendation(filtered.slice(0, filterGroupedRecommendation.size));
    //     }
    // }, [filterGroupedRecommendation, FilteredGroupedRecoommendation.length > 0]);


    useEffect(() => {
        if (filterRecommendation && recommendationFiltered.length > 0) {
            var filtered = recommendation.sort((a: any, b: any) => {
                if (filterRecommendation.direction == 'asc') return (a[filterRecommendation.column] > b[filterRecommendation.column]) ? 1 : -1;
                else return (a[filterRecommendation.column] > b[filterRecommendation.column]) ? -1 : 1;
            });

            setRecommendationFiltered(filtered);
            setVisibleRecommendation(filtered.slice(0, filterRecommendation.size));
        }
    }, [filterRecommendation, recommendationFiltered.length > 0]);

    const loadMoreLevel1 = (size?: number) => {
        if (size) setVisibleGroupedRecommendation(FilteredGroupedRecoommendation.slice(0, size))
        else visibleGroupedRecommendation && setVisibleGroupedRecommendation([...visibleGroupedRecommendation, ...FilteredGroupedRecoommendation.slice(visibleGroupedRecommendation.length, visibleGroupedRecommendation.length + 10)])
    };

    const loadMore = (size?: number) => {
        if (size) setVisibleRecommendation(recommendationFiltered.slice(0, size))
        else setVisibleRecommendation([...visibleRecommendation, ...recommendationFiltered.slice(visibleRecommendation.length, visibleRecommendation.length + 10)])
    };

    const onSortChangeLevel1 = (sortData: any) => {
        const { sort, size } = sortData;
        setFilterGroupedRecommendation({ ...filterGroupedRecommendation, column: sort.column, direction: sort.direction, size: size })
    };

    const onSortChange = (sortData: any) => {
        const { sort, size } = sortData;
        setFilterRecommendation({ ...filterRecommendation, column: sort.column, direction: sort.direction, size: size })
    };

    const changeDensity = (density: string) => {
        dispatch({ type: 'PREF_UPDATE', payload: { name: "density", value: density } });
    }
    const [filterVisible, setFilterVisible] = useState(false);


    const opcoesCategorias = [
        { value: '', label: 'Todas', icon: '', color: '' },
        { value: 'Segurança', label: 'Segurança', icon: 'lci lci-shield-check', color: '#d3281d' },
        { value: 'Custo', label: 'Custo', icon: 'icon lci lci-pig', color: '#5969cd' },
        { value: 'Alta disponibilidade', label: 'Alta disponibilidade', icon: 'icon lci lci-cloud', color: '#e273c5' },
        { value: 'Performance', label: 'Performance', icon: 'icon lci lci-lightning-bolt', color: '#a5bf3e' },
        { value: 'Excelência operacional', label: 'Excelência operacional', icon: 'icon lci lci-thumb-up', color: '#b48c48' },
    ];

    const _filterAdvanced = {
        fields: [
            { label: 'Categoria', name: 'category', type: 'select', options: opcoesCategorias },
            { label: 'Assinatura', name: 'subscription', type: 'text' },
        ],
        onChange: (_filter: any, size: number) => setFilterGroupedRecommendation({ ...filterGroupedRecommendation, size: size, term: _filter[0].value.toLowerCase() }),
        visible: filterVisible,
        onChangeVisibility: () => setFilterVisible(!filterVisible)
    }
    const onChagePeriod = (selected: any) => {

    };

    const periodSelection = {
        periods: [
            {
                label: 'Este mês', text: 'Este mês',
                fields: [
                    { name: 'currentMonth', value: 'currentMonth' }
                ],
                default: true
            }
        ],
        customPeriodType: 'month',
        onChange: onChagePeriod
    };

    // const card = [{
    //     type: 'Custom',

    //     position: {
    //         row: 1, col: 1, ColSpan: 3, RowSpan: 1,
    //     },
    //     title: () => {
    //         return <>{
    //             <div className={'lc-segment-title-row'} >
    //                 <div className={'lc-title'}>
    //                     {categories && categories.filter(x => x.displayDescription == 'Segurança') && categories.filter(x => x.displayDescription == 'Segurança').length > 0 ? categories.filter(x => x.displayDescription == 'Segurança')[0].displayDescription : 'Segurança'}
    //                 </div>
    //             </div>
    //         }</>
    //     },
    //     customContentRender: () => {
    //         return <>
    //             {
    //                 categories && categories.filter(x => x.displayDescription == 'Segurança') && categories.filter(x => x.displayDescription == 'Segurança').length > 0 ?
    //                     <IconValue title="" icon={categories ? categories.filter(x => x.displayDescription == 'Segurança')[0].icon : ''}
    //                         value={categories ? categories.filter(x => x.displayDescription == 'Segurança')[0].count.toString() : 0}
    //                         color={categories ? categories.filter(x => x.displayDescription == 'Segurança')[0].color : ''}
    //                         tooltipInfo="" info={<i className={categories ? categories.filter(x => x.displayDescription == 'Segurança')[0].icon : ''}
    //                             style={{ color: categories ? categories.filter(x => x.displayDescription == 'Segurança')[0].color : '', fontSize: '3rem' }} />}
    //                         tooltipInfoPosition="rigth"></IconValue> :
    //                     <LcNoData label="Sem dados no período." size="small" />
    //             }
    //         </>
    //     }
    // }, {
    //     type: 'Custom',

    //     position: {
    //         row: 1, col: 4, ColSpan: 3,
    //         RowSpan: 1,
    //     },
    //     title: () => {
    //         return <>{
    //             <div className={'lc-segment-title-row'} >
    //                 <div className={'lc-title'}>
    //                     {categories && categories.filter(x => x.displayDescription == 'Custo') && categories.filter(x => x.displayDescription == 'Custo').length > 0 ? categories.filter(x => x.displayDescription == 'Custo')[0].displayDescription : 'Custo'}
    //                 </div>
    //             </div>
    //         }</>
    //     },
    //     customContentRender: () => {
    //         return <> {categories && categories.filter(x => x.displayDescription == 'Custo') && categories.filter(x => x.displayDescription == 'Custo').length > 0 ?
    //             <IconValue title="" icon={categories ? categories.filter(x => x.displayDescription == 'Custo')[0].icon : ''}
    //                 value={categories ? categories.filter(x => x.displayDescription == 'Custo')[0].count.toString() : 0}
    //                 color={categories ? categories.filter(x => x.displayDescription == 'Custo')[0].color : ''} tooltipInfo=""
    //                 info={<i className={categories ? categories.filter(x => x.displayDescription == 'Custo')[0].icon : ''}
    //                     style={{ color: categories ? categories.filter(x => x.displayDescription == 'Custo')[0].color : '', fontSize: '3rem' }} />}
    //                 tooltipInfoPosition="rigth"></IconValue> : <LcNoData label="Sem dados no período." size="small" />}</>
    //     }
    // }, {
    //     type: 'Custom',

    //     position: {
    //         row: 1, col: 9, ColSpan: 2,
    //         RowSpan: 1,
    //     },
    //     title: () => {
    //         return <>{
    //             <div className={'lc-segment-title-row'} >
    //                 <div className={'lc-title'}>
    //                     {categories && categories.filter(x => x.displayDescription == 'Performance') && categories.filter(x => x.displayDescription == 'Performance').length > 0 ? categories.filter(x => x.displayDescription == 'Performance')[0].displayDescription : 'Performance'}
    //                 </div>
    //             </div>
    //         }</>
    //     },
    //     customContentRender: () => {
    //         return <> {categories && categories.filter(x => x.displayDescription == 'Performance') && categories.filter(x => x.displayDescription == 'Performance').length > 0 ? <IconValue title="" icon={categories ? categories.filter(x => x.displayDescription == 'Performance')[0].icon : ''} value={categories ? categories.filter(x => x.displayDescription == 'Performance')[0].count.toString() : 0} color={categories ? categories.filter(x => x.displayDescription == 'Performance')[0].color : ''} tooltipInfo="" info={<i className={categories ? categories.filter(x => x.displayDescription == 'Performance')[0].icon : ''} style={{ color: categories ? categories.filter(x => x.displayDescription == 'Performance')[0].color : '', fontSize: '3rem' }} />}
    //             tooltipInfoPosition="rigth"></IconValue> : <LcNoData label="Sem dados no período." size="small" />}</>
    //     }
    // }, {
    //     type: 'Custom',

    //     position: {
    //         row: 1, col: 7, ColSpan: 2,
    //         RowSpan: 1,
    //     },
    //     title: () => {
    //         return <>{
    //             <div className={'lc-segment-title-row'} >
    //                 <div className={'lc-title'}>
    //                     {categories && categories.filter(x => x.displayDescription == 'Alta disponibilidade') && categories.filter(x => x.displayDescription == 'Alta disponibilidade').length > 0 ? categories.filter(x => x.displayDescription == 'Alta disponibilidade')[0].displayDescription : 'Alta disponibilidade'}
    //                 </div>
    //             </div>
    //         }</>
    //     },
    //     customContentRender: () => {
    //         return <> {categories && categories.filter(x => x.displayDescription == 'Alta disponibilidade') && categories.filter(x => x.displayDescription == 'Alta disponibilidade').length > 0 ? <IconValue title="" icon={categories ? categories.filter(x => x.displayDescription == 'Alta disponibilidade')[0].icon : ''} value={categories ? categories.filter(x => x.displayDescription == 'Alta disponibilidade')[0].count.toString() : 0} color={categories ? categories.filter(x => x.displayDescription == 'Alta disponibilidade')[0].color : ''} tooltipInfo="" info={<i className={categories ? categories.filter(x => x.displayDescription == 'Alta disponibilidade')[0].icon : ''} style={{ color: categories ? categories.filter(x => x.displayDescription == 'Alta disponibilidade')[0].color : '', fontSize: '3rem' }} />}
    //             tooltipInfoPosition="rigth"></IconValue> : <LcNoData label="Sem dados no período." size="small" />}</>
    //     }
    // }, {
    //     type: 'Custom',

    //     position: {
    //         row: 1, col: 11, ColSpan: 2,
    //         RowSpan: 1,
    //     },
    //     title: () => {
    //         return <>{
    //             <div className={'lc-segment-title-row'} >
    //                 <div className={'lc-title'}>
    //                     {categories && categories.filter(x => x.displayDescription == 'Excelência operacional') && categories.filter(x => x.displayDescription == 'Excelência operacional').length > 0 ? categories.filter(x => x.displayDescription == 'Excelência operacional')[0].displayDescription : 'Excelência operacional'}
    //                 </div>
    //             </div>
    //         }</>
    //     },
    //     customContentRender: () => {
    //         return <>
    //             {
    //                 categories && categories.filter(x => x.displayDescription == 'Excelência operacional') && categories.filter(x => x.displayDescription == 'Excelência operacional').length > 0 ?
    //                     <IconValue title="" icon={categories ? categories.filter(x => x.displayDescription == 'Excelência operacional')[0].icon : ''}
    //                         value={categories ? categories.filter(x => x.displayDescription == 'Excelência operacional')[0].count.toString() : 0}
    //                         color={categories ? categories.filter(x => x.displayDescription == 'Excelência operacional')[0].color : ''} tooltipInfo=""
    //                         info={<i className={categories ? categories.filter(x => x.displayDescription == 'Excelência operacional')[0].icon : ''}
    //                             style={{ color: categories ? categories.filter(x => x.displayDescription == 'Excelência operacional')[0].color : '', fontSize: '3rem' }} />}
    //                         tooltipInfoPosition="rigth"></IconValue> :
    //                     <LcNoData label="Sem dados no período." size="small" />
    //             }
    //         </>
    //     }
    // }, {
    //     type: 'Custom',

    //     position: {
    //         row: 2, col: 1, ColSpan: 12,
    //         RowSpan: 3,
    //     },
    //     title: () => {
    //         return <>{
    //             <div className={'lc-segment-title-row'} >
    //                 <div className={'lc-title'}>
    //                     {'Recomendações'}
    //                 </div>
    //             </div>
    //         }</>
    //     },
    //     customContentRender: () => {
    //         return <div style={{ minHeight: '100%' }}>    {visibleGroupedRecommendation &&
    //             <LcInfiniteTable
    //                 loading={isLoading}
    //                 columns={columnsLevel1}
    //                 rows={visibleGroupedRecommendation}
    //                 loadMore={loadMoreLevel1}
    //                 disableFilterModal={true}
    //                 filter={_filterAdvanced}
    //                 size={FilteredGroupedRecoommendation.length}
    //                 onSortChange={onSortChangeLevel1}
    //                 height="calc(100% - 120px)"
    //                 density={pref.data?.density || "medium"}
    //             />}</div>
    //     }
    // }]

    const createCard = (opcao, index) => {
        // Procura a categoria em 'categories' e obtém a contagem ou define 0 se não encontrada
        const categoryData = categories?.find(cat => cat.displayDescription === opcao.label) || { count: 0 };

        // Verifica se um filtro está ativo
        const isFilterActive = filterGroupedRecommendation.category || filterGroupedRecommendation.subscription;

        // Verifica se a categoria atual corresponde ao filtro aplicado
        const isCategoryFiltered = filterGroupedRecommendation.category &&
            filterGroupedRecommendation.category.toLowerCase() === opcao.label.toLowerCase();

        // Define a classe do card com base na ativação do filtro e correspondência da categoria
        const cardClass = isFilterActive && !isCategoryFiltered ? 'card-fade' : 'card-active';

        // Define o ColSpan com base no índice do card
        const colSpan = (index === 0 || index === 1) ? 3 : 2;

        // Calcula a posição inicial da coluna
        let colPosition = 1;
        for (let i = 0; i < index; i++) {
            colPosition += (i === 0 || i === 1) ? 3 : 2;
        }

        return {
            type: 'Custom',
            cssClass: cardClass,
            position: {
                row: 1,
                col: colPosition,
                ColSpan: colSpan,
                RowSpan: 1
            },
            title: () => (
                <div className={'lc-segment-title-row'} >
                    <div className={'lc-title ellipsis'}>
                        {opcao.label}
                    </div>
                </div>
            ),
            customContentRender: () => (
                <IconValue
                    title={opcao.label}
                    icon={opcao.icon}
                    value={categoryData.count.toString()}
                    color={opcao.color}
                />
            )
        };
    };

    // Criação dos cards por categoria
    const categoryCards = opcoesCategorias
        .filter(opcao => opcao.label !== 'Todas') // Exclui a categoria "Todas" do mapeamento
        .map((opcao, index) => createCard(opcao, index));

    // Card de Recomendações
    const recommendationsCard = {
        type: 'Custom',
        position: {
            row: 2, col: 1, ColSpan: 12,
            RowSpan: 3,
        }, title: () => (
            <div className={'lc-segment-title-row'}>
                <div className={'lc-title'}>{'Recomendações'}</div>
            </div>
        ),
        customContentRender: () => {
            return <>
                {
                    visibleGroupedRecommendation &&
                    <LcInfiniteTable
                        loading={isLoading}
                        columns={columnsLevel1}
                        rows={visibleGroupedRecommendation}
                        loadMore={loadMoreLevel1}
                        disableFilterModal={true}
                        filter={_filterAdvanced}
                        size={FilteredGroupedRecoommendation.length}
                        onSortChange={onSortChangeLevel1}
                        height="100%"
                        density={pref.data?.density || "medium"}
                    />
                }
            </>
        }
    };

    const cards = [...categoryCards, recommendationsCard];


    const filterSystem = () => {
        return (
            <FilterLcInfiniteTable
                filter={_filterAdvanced.fields}
                onFilterChange={handleFilterChange}
            />
        );
    };

    const applyFilter = useCallback(() => {
        let isFilterActive = false;

        if (groupedRecoommendation.length > 0) {
            let filtered = groupedRecoommendation.filter((p: any) => {
                const matchesCategory = filterGroupedRecommendation.category
                    ? p.category.toLowerCase().includes(filterGroupedRecommendation.category)
                    : true;
                const matchesSubscription = filterGroupedRecommendation.subscription
                    ? p.subscription.toLowerCase().includes(filterGroupedRecommendation.subscription)
                    : true;

                return matchesCategory && matchesSubscription;
            }).sort((a: any, b: any) => {
                if (filterGroupedRecommendation.direction == 'asc') return (a[filterGroupedRecommendation.column] > b[filterGroupedRecommendation.column]) ? 1 : -1;
                else return (a[filterGroupedRecommendation.column] > b[filterGroupedRecommendation.column]) ? -1 : 1;
            });;

            isFilterActive = filtered.length !== groupedRecoommendation.length;
            setFilteredGroupedRecommendation(filtered);
            setVisibleGroupedRecommendation(filtered);
        }

        dispatch(setFilterActive(isFilterActive));
    }, [filterGroupedRecommendation, groupedRecoommendation, dispatch]);

    // UseEffect para chamar applyFilter
    useEffect(() => {
        applyFilter();
    }, [applyFilter]);

    // UseEffect para limpar o filtro ativo quando o componente é desmontado
    useEffect(() => {
        return () => {
            dispatch(setFilterActive(false));
        };
    }, [dispatch]);

    const handleFilterChange = (updatedFilters) => {
        const categoryFilter = updatedFilters.find(f => f.name === 'category')?.value || '';
        const subscriptionFilter = updatedFilters.find(f => f.name === 'subscription')?.value || '';

        setFilterGroupedRecommendation({
            ...filterGroupedRecommendation,
            category: categoryFilter.toLowerCase(),
            subscription: subscriptionFilter.toLowerCase()
        });
    };


    return (
        <Layout pageTitle="Recomendações" periodSelection={periodSelection}
            dots={
                <>
                    <div className='item' style={{ color: pref.data?.density == "high" ? "#abaeb9" : "#000" }} onClick={() => changeDensity("high")}><i className='ppi ppi-view-list' /> Densidade alta</div>
                    <div className='item' style={{ color: pref.data?.density == "medium" ? "#abaeb9" : "#000" }} onClick={() => changeDensity("medium")}><i className='ppi ppi-menu' /> Densidade média</div>
                    <div className='item' style={{ color: pref.data?.density == "low" ? "#abaeb9" : "#000" }} onClick={() => changeDensity("low")}><i className='ppi ppi-menu-alt-4' /> Densidade baixa</div>
                </>
            }
            gridFilter={{
                toggleVisibility: () => {
                    setFilterVisible(!filterVisible)
                },
                size: FilteredGroupedRecoommendation.length
            }}
            loading={isLoading}
        >
            <LCDashboard
                cards={cards}
                rightSidePanel={{
                    title: 'Filtros',
                    pinned: false,
                    show: filterVisible,
                    content: filterSystem,
                }}
            />

            {/*<PPGrid container spacing={2}>*/}
            {/*  {*/}
            {/*    categories?.map((item, i) => {*/}
            {/*      return (*/}
            {/*        <PPGrid item key={i} xs={12} sm={12} md={6} lg={3}>*/}
            {/*          <IconValueCardRow title={item.displayDescription} icon={item.icon} value={item.count.toString()} color={item.color}></IconValueCardRow>*/}
            {/*        </PPGrid>);*/}
            {/*    })*/}
            {/*  }*/}
            {/*</PPGrid>*/}

            <PPModal size='large' title={`Recomendações de ${categorySelected}`} visible={showModal} onClose={setShowModal}>
                <LcInfiniteTable
                    hidePagination={true}
                    loading={isLoading}
                    columns={columns}
                    rows={visibleRecommendation}
                    loadMore={loadMore}
                    size={recommendationFiltered.length}
                    onSortChange={onSortChange}
                />
            </PPModal>

        </Layout>
    );
}

export default AdminRecommendations;